<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="col-lg-12">
            <bita-formgroup title="اطلاعات" class="row px-3">
              <bita-input
                type="text"
                name="title"
                label="عنوان"
                rules="required"
                :validation-container-class="colWidth"
                input-class="form-control"
                v-model="form.title"
              />

              <bita-select
                name="category_id"
                ref="categories"
                label="دسته بندی"
                rules="required"
                :validation-container-class="colWidth"
                input-class="form-control"
                :data-source="categories"
                data-text-field="name"
                data-value-field="id"
                v-model="form.category_id"
              />

              <!-- <bita-texteditor
                name="introduction"
                ref="introduction"
                label="مقدمه"
                validation-container-class="col-12"
                input-class="form-control"
                v-model="form.introduction"
              /> -->

              <bita-texteditor
                type="text"
                name="content"
                ref="content"
                label="توضیحات"
                validation-container-class="col-12"
                input-class="form-control"
                v-model="form.content"
              />
            </bita-formgroup>

            <bita-formgroup title="تاریخ" class="row px-3">
              <bita-datepicker
                type="datetime"
                id="paymentat"
                rules="required"
                :validation-container-class="colWidth"
                name="publish_at"
                label="تاریخ انتشار"
                inputClass="form-control"
                class="ml-2"
                v-model="form.publish_at"
                format="YYYY-MM-DD HH:mm:ss"
                display-format="jYYYY/jMM/jDD HH:mm:ss"
              />

              <bita-datepicker
                type="datetime"
                id="paymentat"
                rules="required|after:@تاریخ انتشار"
                :validation-container-class="colWidth"
                name="expire_at"
                label="تاریخ انقضا"
                inputClass="form-control"
                v-model="form.expire_at"
                format="YYYY-MM-DD HH:mm:ss"
                display-format="jYYYY/jMM/jDD HH:mm:ss"
              />
            </bita-formgroup>

            <bita-formgroup title="بیشتر" class="row">
              <bita-input
                type="text"
                name="link"
                label="لینک"
                :validation-container-class="colWidth"
                input-class="form-control"
                v-model="form.link"
              />

              <bita-select
                name="is_special"
                rules="required"
                ref="is_special"
                label="ویژه"
                :validation-container-class="colWidth"
                input-class="form-control"
                :data-source="[
                  { id: 1, name: 'بله' },
                  { id: 0, name: 'خیر' },
                ]"
                data-text-field="name"
                data-value-field="id"
                v-model="form.is_special"
              />

              <bita-uploader
                name="thumbnail"
                label="تصویر"
                ref="uploader"
                rules="size:50"
                :validation-container-class="colWidth"
                input-class="form-control"
                v-model="form.thumbnail"
                :icon-url="form.thumbnail_url"
              />

              <bita-select
                name="is_private"
                ref="is_private"
                rules="required"
                label="این مقاله خصوصی هست"
                :validation-container-class="colWidth"
                input-class="form-control"
                :data-source="[
                  { id: 1, name: 'بله' },
                  { id: 0, name: 'خیر' },
                ]"
                data-text-field="name"
                data-value-field="id"
                v-model="form.is_private"
              />

              <bita-multiselect
                v-if="form.is_private == 1"
                label="کاربران"
                name="users"
                rules="required"
                validation-container-class="col-lg-12"
                :data-source="users"
                data-text-field="name"
                data-value-field="id"
                v-model="form.users"
              />
                          <bita-input
                type="text"
                name="priority"
                label="اولویت"
                validation-container-class="col-lg-4"
                input-class="form-control"
                v-model="form.priority"
            />
            </bita-formgroup>
          </div>
        </div>
      </bita-form>
      <div slot="footer">
        <bita-bootbutton
          v-if="!propsData.id"
          type="primary"
          title="ذخیره"
          icon="fa fa-check"
          btn-width="150px"
          @click.native="handleSubmit()"
        />
        <bita-bootbutton
          v-if="propsData.id"
          type="primary"
          title="بروزرسانی"
          icon="fa fa-check"
          btn-width="150px"
          @click.native="handleSubmit()"
        />
        <bita-bootbutton
          class="mr-2"
          type="danger"
          title="بستن"
          icon="fas fa-times"
          btn-width="150px"
          data-dismiss="modal"
          @click.native="
            () => {
              $emit('change-status-modal');
            }
          "
        />
      </div>
    </div>
  </bita-modal>
</template>

<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    propsData: {},
    propsCategories: [],
    propsUsers: [],
  },
  data() {
    return {
      colWidth: "col-lg-4",
      form: {},
      users: [],
      categories: [],
    };
  },
  watch: {
    propsData: function(_data) {
      if (!!_data.id) {
        this.form = { ..._data };
        this.form.thumbnail_url = this.form.thumbnail;
        this.form.thumbnail = "";

        const users = this.form.users;
        this.form.users = [];
        users.forEach((user) => {
          this.form.users.push(user.id);
        });
      } else {
        this.form = {
          title: "",
          link: "",
          category_id: "",
          introduction: "",
          content: "",
          publish_at: "",
          expire_at: "",
          is_special: 0,
          thumbnail: "",
          thumbnail_url: "",
          is_private: 0,
          priority:0,
          users: [],
        };
      }
    },
    propsCategories: function(_data) {
      this.categories = _data;
    },
    propsUsers: function(_data) {
      this.users = _data;
    },
  },
  methods: {
    toggleLoading() {
      this.$emit("isLoading");
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.form.content = this.form.content.replaceAll(/( {2})/g, "");
          this.$emit("on-submit", this.form);
        }
      });
    },
    onCloseModal() {
      this.$refs.form.reset();
    },
  },
};
</script>
